import { appConfig } from '../config';

export const BANNER_SLOT = 'desktop';
export const BANNER_EXT = 'jpg';

function bannerBaseUrl(): string {
    return appConfig.media.cdnImageBaseUrl.replace(/\/+$/, '');
}

export function normalizeBannerSegment(value: string): string {
    return String(value || '').trim().toUpperCase().replace(/\s+/g, '_');
}

/** Global ordretype: .../order-types/{ORDER_TYPE}/desktop.jpg */
export function orderTypeBannerUrl(
    orderType: string,
    slot: string = BANNER_SLOT,
    ext: string = BANNER_EXT
): string {
    const segment = normalizeBannerSegment(orderType);
    return `${bannerBaseUrl()}/media/banners/order-types/${segment}/${slot}.${ext}`;
}

/**
 * B2B collection under ordretype:
 * .../seasons/{ORDER_TYPE}/collections/{COLLECTION}/desktop.jpg
 */
export function orderTypeCollectionBannerUrl(
    orderType: string,
    collection: string,
    slot: string = BANNER_SLOT,
    ext: string = BANNER_EXT
): string {
    const orderTypeSeg = normalizeBannerSegment(orderType);
    const collectionSeg = normalizeBannerSegment(collection);
    return `${bannerBaseUrl()}/media/banners/seasons/${orderTypeSeg}/collections/${collectionSeg}/${slot}.${ext}`;
}
